<template>
    <div>
      <div class="flex justify-between items-center xs-hide sm-hide">
        <div>
          <p class="h5n m0 bold">{{ getReferencelabel('SECONDARY_ACCOUNT') }}</p>
          <p class="h6n m0">{{ getReferencelabel('CREATION_PLATFORM') }}: {{ externalContext.partner.toUpperCase() }}</p>
        </div>
      </div>
      <!-- Mobile -->
      <div class="flex flex-column center items-center lg-hide md-hide">
        <div>
          <p class="h5n m0 bold">{{ getReferencelabel('SECONDARY_ACCOUNT') }}</p>
          <p class="h6n m0">{{ getReferencelabel('CREATION_PLATFORM') }}: {{ externalContext.partner.toUpperCase() }}</p>
        </div>
      </div>

      <div class="grid gap3 pt3 form-row">
        <FormInput
          class="grid-col-4"
          :id="`gender-${index}`"
          type="radio"
          label="TITLE"
          :value="externalContext.user.gender"
          :options="[
            { value: 'mr', text: 'Monsieur' },
            { value: 'mme', text: 'Madame' }
          ]"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`firstname-${index}`"
          type="text"
          label="FIRST_NAME"
          placeholder="YOUR_FIRST_NAME"
          :value="externalContext.user.firstname"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`lastname-${index}`"
          type="text"
          label="LAST_NAME"
          placeholder="YOUR_LAST_NAME"
          :value="externalContext.user.lastname"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`nationality-${index}`"
          type="select"
          label="NATIONALITY"
          placeholder="Votre nationalité"
          :value="externalContext.user.nationality"
          :options="countryOptions"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`birth_date-${index}`"
          type="text"
          label="BIRTH_DATE"
          placeholder="Ex: 27/03/1980"
          :value="externalContext.user.birth_date"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`email-${index}`"
          type="email"
          label="EMAIL"
          :value="externalContext.user.email"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`mobilephone-${index}`"
          type="tel"
          label="PHONE_NUMBER"
          placeholder="MOBILE_PLACEHOLDER"
          :value="externalContext.user.mobilephone"
          :disabled="true"
        />

        <FormInput
          class="grid-col-3"
          :id="`country-${index}`"
          type="select"
          label="COUNTRY"
          placeholder="Votre pays de résidence"
          :value="externalContext.user.country"
          :options="countryOptions"
          :disabled="true"
        />

        <FormInput
          class="grid-col-1"
          :id="`zip_code-${index}`"
          type="text"
          label="ZIP_CODE"
          :value="externalContext.user.zip_code"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`town-${index}`"
          type="text"
          label="CITY"
          :value="externalContext.user.town"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`street_number-${index}`"
          type="text"
          label="ADDRESS_1"
          :value="externalContext.user.street_number"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`street_name-${index}`"
          type="text"
          label="ADDRESS_2"
          :value="externalContext.user.street_name"
          :disabled="true"
        />

        <FormInput
          class="grid-col-4"
          :id="`address2-${index}`"
          type="text"
          label="ADDRESS_COMPLEMENT"
          :value="externalContext.user.address2"
          :disabled="true"
        />
    </div>
  </div>
</template>

<script>
import FormInput from '@/components/inputs/FormInput';
import { countryOptions, getReferencelabel } from '@/mixins/utils';

export default {
  name: 'ExternalContextsDataForm',
  components: { FormInput },
  props: {
    index: {
      type: Number,
      required: true,
    },
    externalContext: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      countryOptions,
      getReferencelabel,
    };
  },
};
</script>